import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as MuiSystem from '@material-ui/system';
import { style as style$1, typography as typography$1 } from '@material-ui/system';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _typeof from '@babel/runtime/helpers/typeof';

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-explicit-any */

// Note this is a clone of:
// https://github.com/mui/material-ui/blob/bda562b435a70e3e8f6d7fb04581c6816a5ba0c7/packages/material-ui-system/src/compose.js
// With the only difference being use of clone vs. mutation (see note below)

function isPlainObject(item) {
  return item && _typeof(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source, options) {
  var output = options.clone ? _objectSpread$2({}, target) : /* istanbul ignore next */target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      /* istanbul ignore next */
      if (key === '__proto__') {
        return;
      }
      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}
var compose$1 = function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  var fn = function fn(props) {
    return styles.reduce(function (acc, style) {
      var output = style(props);
      if (output) {
        return deepmerge(acc, output, {
          clone: true /* nb. this is hardcoded to false in MUI */
        });
      }

      return acc;
    }, {});
  };
  var filterProps = styles.reduce(function (acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  fn.filterProps = filterProps;
  return fn;
};

var _excluded = ["map"];
function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var typographyKey = 'typography';
var themeKey = 'typography';
var variants = style$1({
  prop: typographyKey,
  cssProperty: false,
  themeKey: themeKey
});
var typographyFn = compose$1(variants, typography$1);
var typography = function typography(props) {
  var typographyProp = props[typographyKey];
  if (!typographyProp) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typographyFn(props);
  }
  var themeTypography = props.theme[themeKey];
  var typographyValue = themeTypography[typographyProp];
  if (typographyValue && 'map' in typographyValue) {
    var map = typographyValue.map,
      rest = _objectWithoutProperties(typographyValue, _excluded);
    return typographyFn(_objectSpread$1(_objectSpread$1(_objectSpread$1({}, rest), props), {}, {
      typography: map
    }));
  }
  return typographyFn(props);
};

// inherited from MUI so width / height continue to behave as usual

var transform = function transform(value) {
  return typeof value === 'number' && value <= 1 ? "".concat(value * 100, "%") : value; // no way to know if the value is of correct type, leave it to pass an invalid value and css will apply an invalid value
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var borders = MuiSystem.borders,
  compose = MuiSystem.compose,
  css = MuiSystem.css,
  display = MuiSystem.display,
  flexbox = MuiSystem.flexbox,
  palette = MuiSystem.palette,
  positions = MuiSystem.positions,
  shadows = MuiSystem.shadows,
  sizing = MuiSystem.sizing,
  spacing = MuiSystem.spacing,
  style = MuiSystem.style;
var border = style({
  prop: 'border',
  themeKey: 'borders'
});
var borderTop = style({
  prop: 'borderTop',
  themeKey: 'borders'
});
var borderBottom = style({
  prop: 'borderBottom',
  themeKey: 'borders'
});
var borderLeft = style({
  prop: 'borderLeft',
  themeKey: 'borders'
});
var borderRight = style({
  prop: 'borderRight',
  themeKey: 'borders'
});
var borderRadius = style({
  prop: 'borderRadius',
  themeKey: 'radii'
});
var gap = style({
  prop: 'gap'
});
var width = style({
  prop: 'width',
  themeKey: 'size',
  transform: transform
});
var height = style({
  prop: 'height',
  themeKey: 'size',
  transform: transform
});
// the "composed" function `all` is a combination of all the system functions
// ordering matters, later functions take precedence
// it runs through any keys in the s({}) function and checks if it maps to any of the style functions
var all = compose(borders, border, borderTop, borderBottom, borderLeft, borderRight, borderRadius, display, flexbox, gap, palette, positions, shadows, sizing, spacing, typography, width, height);
var sizingSpacing = compose(sizing, spacing);
var system = function system(props) {
  return function (_ref) {
    var theme = _ref.theme;
    return all(_objectSpread({
      theme: theme
    }, props));
  };
};

export { all, borders, compose, css, display, flexbox, palette, positions, shadows, sizing, sizingSpacing, spacing, style, system, typography };
